<template>
    <div>
        <v-app-bar id="nav-bar" app min-width="100vw">
            <div id="cancel-button-container">
            <v-icon v-if="sessionValid" id="cancel-button" @click="openCancelModal">$times</v-icon>
            </div>
            <div id="clear-choice-logo-container">
            <router-link to="/">
                <ResponsiveImage v-if="stateLogoCheck" id="clear-choice-logo" :image-url="logoImage" width="136px"  height="40px" />
            </router-link>
            </div>
            <div id="faq-button-container">
                <v-icon id="faq-button"  @click.stop="showContextHelp = !showContextHelp">$vuetify.icon.questionCircle</v-icon>
            </div>
        </v-app-bar>
        <CancelApplicationModal :show-modal="showCancelModal" @close-cancel-modal="closeCancelModal" />
        <FAQDrawer
            v-model="showContextHelp"
        ></FAQDrawer>
    </div>
</template>

<script>
import {helpService} from "@/service"
import {applicationState} from "@/state"
import {mapGetters, mapState} from "vuex"
import CancelApplicationModal from "@/components/modal/CancelApplicationModal"
import FAQDrawer from "@/components/drawer/FAQDrawer.vue";
import SessionState from "@/state/SessionState";

export default {
        name: "NavBar",
        components: {
            FAQDrawer,
            CancelApplicationModal,
        },
        data: () => ({
            application: applicationState.application,
            eduDrawer: false,
            mainDrawer: false,
            glossaryEntries: [],
            mainGroup: null,
            showCancelModal: false,
            logoImage: require("@/assets/clearchoice/images/clearchoice-logo.png"),
            showContextHelp: false,
        }),

        computed: {
            ...mapGetters(["applicantInfo"]),


            ...mapState("session", {
                sessionValid: state => !!state.data.dynamicProviderKey?.providerKey,
            }),

            stateLogoCheck() {
                const noLogoStates = ["IL"];
                return !noLogoStates.some(noLogoState => SessionState.session.properties.state === noLogoState)
            }

        },

        watch: {
            mainGroup() {
                this.drawer = false
            },
        },

        created() {
            helpService.findGlossaryEntries().then(({ entries }) => (this.glossaryEntries = entries))
        },

        methods: {
            openCancelModal() {
                this.showCancelModal = true
            },

            closeCancelModal() {
                this.showCancelModal = false
            },

        },
    }
</script>

<style lang="scss" scoped>
    #nav-bar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100vw;
    }

    @media only screen and (min-width: 960px) {
        #faq-button {
            display: none;
        }
    }

    .navigation-drawer {
        width: 560px !important;
        position: fixed;
        top: 0;
        right: 0;
        overflow-y: scroll;
    }

    .qrcode {
        margin: auto;
        max-width: 250px;
    }

    .v-btn {
        padding: 0 !important;
    }

</style>
